import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'draw-on-image',
  templateUrl: './draw-on-image.component.html',
  styleUrls: ['./draw-on-image.component.css']
})
export class DrawOnImageComponent implements OnInit, OnChanges {
  @Input() ImagePath: string;
  @Input() ImageSrc: string;
  @Input() Height: number = 300;
  @Input() Width: number =300;
  @ViewChild('canvas') canvasRef: ElementRef;
  private ctx: CanvasRenderingContext2D;
  private isDrawing = false;
  private lastX: number;
  private lastY: number;
  public savedImage: HTMLImageElement;
  private imageLoaded = false;
  private image: HTMLImageElement;
  private shapeHistory: Path2D[] = [];
  private currentShape: Path2D;
  sourceImage: string;
  sourceImageId: any = '';
  constructor(private renderer: Renderer2) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    this.loadImageFromAssets();
  }
  ngOnInit() {

  }
  ngAfterViewInit() {
    this.ctx = this.canvasRef.nativeElement.getContext('2d');
    this.loadImageFromAssets();
  }

  loadImageFromAssets() {
    this.sourceImage = this.ImageSrc ? this.ImageSrc : this.ImagePath;
    if (this.ImagePath) {
      this.sourceImageId = this.sourceImage.split("/")[this.sourceImage.split("/").length - 1];
    } else if (this.ImageSrc) {
      this.sourceImageId = this.sourceImage.split(",")[1].substring(0, 7);
    }
    this.image = new Image();
    this.image.src = this.sourceImage;
    this.image.onload = () => {
      this.imageLoaded = true;
      this.ctx.drawImage(this.image, 0, 0, this.Width, this.Height);
    };
  }
  onMouseDown(event: MouseEvent) {
    if (!this.imageLoaded) return;
    this.isDrawing = true;
    const canvasRect = this.canvasRef.nativeElement.getBoundingClientRect();
    this.lastX = event.clientX - canvasRect.left;
    this.lastY = event.clientY - canvasRect.top;
    this.currentShape = new Path2D();
    this.currentShape.moveTo(this.lastX, this.lastY);
  }
  onMouseMove(event: MouseEvent) {
    if (!this.isDrawing) return;
    const canvasRect = this.canvasRef.nativeElement.getBoundingClientRect();
    const newX = event.clientX - canvasRect.left;
    const newY = event.clientY - canvasRect.top;
    this.currentShape.lineTo(newX, newY);
    this.ctx.clearRect(0, 0, this.canvasRef.nativeElement.width, this.canvasRef.nativeElement.height);
    this.ctx.drawImage(this.image, 0, 0, this.Width, this.Height);
    this.ctx.strokeStyle = 'red';
    this.ctx.lineWidth = 2;
    for (const shape of this.shapeHistory) {
      this.ctx.stroke(shape);
    }
    this.ctx.stroke(this.currentShape);
  }
  onMouseUp() {
    if (!this.isDrawing) return;
    this.isDrawing = false;
    this.shapeHistory.push(this.currentShape);
    this.currentShape = null;
    this.saveImageWithShapes()
  }
  undoLastChange() {
    this.shapeHistory.pop();
    this.ctx.clearRect(0, 0, this.canvasRef.nativeElement.width, this.canvasRef.nativeElement.height);
    this.ctx.drawImage(this.image, 0, 0, this.Width, this.Height);
    for (const shape of this.shapeHistory) {
      this.ctx.stroke(shape);
    }
    this.saveImageWithShapes()
  }

  clearCanvas() {
    if (!this.imageLoaded) return;
    this.ctx.clearRect(0, 0, this.canvasRef.nativeElement.width, this.canvasRef.nativeElement.height);
    this.ctx.drawImage(this.image, 0, 0, this.Width, this.Height);
    this.shapeHistory = [];
    this.currentShape = null;
    this.saveImageWithShapes()
  }

  saveImageWithShapes() {
    this.savedImage = new Image();
    this.savedImage.src = this.canvasRef.nativeElement.toDataURL('image/png');
    this.savedImage.width = 65;
    this.savedImage.height = 65;
    const savedImageContainer = document.getElementById(this.sourceImageId + 'savedImageContainer');
    savedImageContainer.innerHTML = '';
    savedImageContainer.appendChild(this.savedImage);
  }
  getImageSrc() {
    if (this.savedImage) {
      return this.savedImage.src;
    }else
    return
  }
}
